export const DEFAULT_MAX_FILE_SIZE = 10 * 1024 * 1024;

export const readFileAsBase64Payload = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = reader.result || "";
      const base64Content = String(result).includes(",")
        ? String(result).split(",")[1]
        : String(result);

      resolve({
        Name: file.name,
        Content: base64Content,
        ContentType: file.type || "application/octet-stream",
        FileSize: file.size || 0,
      });
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

export const getFileExtension = (fileName = "") => {
  const lastIndex = fileName.lastIndexOf(".");
  return lastIndex !== -1 ? fileName.substring(lastIndex + 1).toLowerCase() : "";
};

export const isAllowedFile = (file, { allowedExtensions = [], allowedMimeTypes = [] } = {}) => {
  const extension = getFileExtension(file?.name || "");
  const hasValidExtension = allowedExtensions.includes(extension);
  const hasValidMimeType = allowedMimeTypes.includes(file?.type);

  return hasValidExtension && hasValidMimeType;
};

export const findInvalidFile = (files = [], options = {}) =>
  files.find((file) => !isAllowedFile(file, options));

export const findOversizedFile = (files = [], maxFileSize = DEFAULT_MAX_FILE_SIZE) =>
  files.find((file) => file.size > maxFileSize);
